import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

export const SendToOrder = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="-1 -2.5 24 24" data-testid="SendToOrderIcon">
      <path
        d="M7 4.5h3v9h2v-9h3l-4-4Zm13-4h-6.5l2 2H20v14H2v-14h4.5l2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
